import { useEffect, useRef, useState } from 'react';

export default function Features() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} id="event" className="py-16 sm:py-28 bg-[#0F0F0F] relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-[#14B8A6]/3 via-transparent to-transparent"></div>
      
      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-8">
        <div className={`text-center mb-12 sm:mb-20 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="inline-block px-5 sm:px-6 py-2 sm:py-2.5 bg-gradient-to-r from-[#14B8A6]/10 to-[#0D9488]/10 border border-[#14B8A6]/30 rounded-full mb-4 sm:mb-6 backdrop-blur-sm">
            <span className="text-[13px] sm:text-[14px] font-semibold text-[#14B8A6] tracking-wide">특별한 학습 경험</span>
          </div>
          <h2 className="text-[40px] sm:text-[52px] lg:text-[60px] font-bold text-white mb-4 sm:mb-6 leading-tight tracking-tight px-4">
            왜 LEXO인가?
          </h2>
          <p className="text-[15px] sm:text-[18px] text-gray-400 max-w-2xl mx-auto leading-relaxed px-4">
            체계적인 커리큘럼과 검증된 학습법으로<br />
            자연스럽고 효과적인 일본어 실력을 키워보세요
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 gap-2 sm:gap-6 md:gap-8 max-w-3xl mx-auto">
        </div>
      </div>
    </section>
  );
}
